import { IPrices } from '../../../models/Price/mappers/mapResponseToPriceGrid'
import { IStore } from '../../index'

export function getPrices(state: IStore): IPrices[] {
  return state.price.prices
}

export const getPriceConfig = (state: IStore) => state.price.config

export const getPriceDiff = (state: IStore) => state.price.diff

export const getSettingsData = (state: IStore) => state.price.settingsData

export const getRoomModalEditOpen = (state: IStore) => state.price.editRoomOpen
export const getRoomModalEditOpenId = (state: IStore) => state.price.editRoomId
export const getRoomModalEditSettings = (state: IStore) =>
  state.price.roomSettings
export const getRoomModalEditAirbnbErrors = (state: IStore) =>
  state.price.airbnbSettingsErrors
export const getRoomModalEditBookingErrors = (state: IStore) =>
  state.price.bookingSettingsErrors
export const getPriceSettingsCloseModal = (state: IStore) =>
  state.price.closeModal
export const getRoomModalEditFromPrice = (state: IStore) =>
  state.price.editRoomPrice
export const getPriceSettingsErrors = (state: IStore) => state.price.errors
export const getPriceSettingsAction = (state: IStore) => state.price.action

export const getProvisionPopoutState = (state: IStore) =>
  state.price.provisionPopout
export const getPricesRoomExpanded = (state: IStore) =>
  state.price.roomsExpanded

export const getPriceGridScroll = (state: IStore) => state.price.scroll
export const getRoomModalEditFilter = (state: IStore) => state.price.int

export const getPriceGridExpanded = (state: IStore) => state.price.expanded

export const getFeeModalOpen = (state: IStore) => state.price.feeModal

export const getNewPrices = (state: IStore) => state.price.newPrices
export const getNewPricesLoading = (state: IStore) =>
  state.price.newPricesLoading
export const getRoomSettingsGlobal = (state: IStore) =>
  state.price.roomSettingsGlobal
export const getRoomSettingsLoadingGlobal = (state: IStore) =>
  state.price.loadingGlobal
export const getPriceGridFilter = (state: IStore) => state.price.priceGridFilter
export function getPriceGridFilterCount(state: IStore): number {
  const f = state.price.priceGridFilter
  if (!f) return 0
  let n = 0
  if (f.channels) {
    if (f.channels.airbnb) n += 1
    if (f.channels.bedbooking) n += 1
    if (f.channels.booking) n += 1
  }
  if (f.capacities && typeof f.capacities === 'object') {
    n += Object.values(f.capacities).filter(Boolean).length
  }
  return n
}
export const getPriceConfigLoading = (state: IStore) =>
  state.price.configLoading
